module.exports = __webpack_public_path__ + "images/6-i820fc63177103bfa5a3bdb6730401ada.svg";